import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  ParamMap,
  Router,
  RouterStateSnapshot
} from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../../../auth';

/**
 * Redirects to the service's login, preserving the sid and app from the query params.
 * @param router
 * @param queryParams Query params of the route protected by the guard
 */
const navToLogin = (router: Router, queryParams: ParamMap) => {
  router
    .navigate(['login'], {
      queryParams: { sid: queryParams.get('sid'), app: queryParams.get('app') },
      replaceUrl: true
    })
    .then();
};

/**
 * Guard for the OTP verification route: requires that the navigation comes from
 * a login with a pending two-factor step, and validates the associated scoped
 * token before granting access. If there are no credentials in the navigation
 * state or the token isn't valid, redirects back to the login.
 */
export const ProfileGuard: CanActivateFn = async (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const router: Router = inject(Router);
  const authService: AuthService = inject(AuthService);

  const credentials = route.queryParamMap.get('token');
  if (!credentials) {
    navToLogin(router, route.queryParamMap);
    return false;
  }

  const tokenData = await authService.verifyTwoFactorToken(credentials).catch(() => {
    navToLogin(router, route.queryParamMap);
  });

  return !!tokenData?.isValid;
};
